module.exports = __webpack_public_path__ + "img/jo3.352f564a.png";